export default {
  BarcodeConfiguration: {
    Barcode: '条形码',
    Import: '导入',
    Product: '商品条形码模板',
    Excel: 'Excel导入商品条形码规则说明：',
    already: '如果系统已存在商品条形码资料，根据商品条形码更新数据，否则新建商品条形码信息',
    download: '导入供应商信息模板，点击下载',
    Importing: '导入Excel格式必须带标题，红色标题为必填；Excel的列请设置为文本格式，不然可能会出现类型转换错误的问题',
    Supports: '支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过6万行，如果超过，请分成多次导入。',
    Operation: '操作中，是否继续?',
    available: '可用',
    Unavailable: '不可用',
  },
};
